import React from "react";
import { Typography } from "@mui/material";
import { APP_VERSION } from "../config/appVersion";
import { getMessage, useLocale } from "../i18n/locale";

export default function AppVersion({ sx }) {
  const { locale } = useLocale();
  const label = getMessage(locale, "appVersion").replace("{version}", APP_VERSION);

  return (
    <Typography component="span" variant="caption" color="text.secondary" sx={sx}>
      {label}
    </Typography>
  );
}
